import { render, staticRenderFns } from "./RDataUrlCard.vue?vue&type=template&id=df9ebe30&scoped=true&"
import script from "./RDataUrlCard.vue?vue&type=script&lang=js&"
export * from "./RDataUrlCard.vue?vue&type=script&lang=js&"
import style0 from "./RDataUrlCard.vue?vue&type=style&index=0&id=df9ebe30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df9ebe30",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VIcon})
